import { api } from '@/lib/axios-client'
import type {
  Role,
  RolePayload,
  RolePermission,
} from '../types/roles-permissions-types'

type GetRolesOptions = {
  assignableOnly?: boolean
}

export async function getRoles(
  cityKey?: string | null,
  options?: GetRolesOptions,
): Promise<Role[]> {
  const params: { cityKey?: string; assignableOnly?: boolean } = {}
  if (cityKey) params.cityKey = cityKey
  if (options?.assignableOnly) params.assignableOnly = true
  const response = await api.get<Role[]>('/Roles', { params })
  return response ?? []
}

export async function getRoleById(id: string): Promise<Role | null> {
  const response = await api.get<Role>(`/Roles/${id}`)
  return response ?? null
}
export async function addRole(role: RolePayload): Promise<void> {
  await api.post('/Roles', role)
}

export async function editRole(id: string, role: RolePayload): Promise<void> {
  await api.put(`/Roles/${id}`, role)
}

export async function deleteRole(id: string): Promise<void> {
  await api.delete(`/Roles/${id}`)
}

export async function getPermissions(): Promise<RolePermission[] | null> {
  const response = await api.get<RolePermission[]>('/Permissions')
  return response ?? null
}
